import { createContext } from 'react';

type DarkModeContextType = {
  isDarkMode: boolean;
  setIsDarkMode: (val: boolean) => void;
};

export const DarkModeContext = createContext<DarkModeContextType | undefined>(undefined);
